<template>
  <div>
    <v-dialog
      content-class="bra-20"
      v-model="DIALOG_ATIVO"
      persistent
      width="550"
      transition="dialog-top-transition"
    >
      <v-card>
        <v-card-title>
          <span>{{ editando ? "Editando" : "Cadastrando" }}</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="fecharDialog()" class="ml-n2">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="mt-3">
          <div class="d-flex">
            <div class="w-50-porcento">
              <SysGrupoAutocomplete
                v-model="editedItem.grupo"
                label="Selecione o Grupo*"
                class="mr-2"
                outlined
                :disabled="editedItem.id > 0"
                :error-messages="grupoErros"
                @change="messageError = null"
              />
            </div>

            <div class="w-50-porcento">
              <SysFilialGrupoAutocomplete
                v-model="editedItem.filial"
                :id-grupo="editedItem.grupo || 0"
                label="Selecione a Filial*"
                class="ml-2"
                outlined
                multiple
                :qtde-visivel-selecionados="5"
                :disabled="editedItem.id > 0"
                :error-messages="filialErros"
                @change="messageError = null"
              />
            </div>
          </div>

          <div class="d-flex">
            <div class="w-50-porcento">
              <v-select
                v-model="editedItem.pqr"
                label="Selecione P, Q ou R*"
                :items="select.pqr"
                item-text="text"
                item-value="value"
                outlined
                class="mr-2"
                :error-messages="pqrErros"
                @change="messageError = null"
              ></v-select>
            </div>

            <div class="w-50-porcento">
              <v-select
                v-model="editedItem.xyz"
                label="Selecione X, Y ou Z*"
                :items="select.xyz"
                item-text="text"
                item-value="value"
                outlined
                class="ml-2"
                :error-messages="xyzErros"
                @change="messageError = null"
              ></v-select>
            </div>
          </div>

          <text-field-formatador
            v-model="editedItem.tempo_cobertura"
            label="Informe o Tempo de Cobertura*"
            outlined
            inteiro
            :remover-valor-irrelevante="true"
            :error-messages="tempoCoberturaErros"
            @focus="$event.target.select()"
            @keyup.enter="salvar()"
          ></text-field-formatador>
        </v-card-text>

        <v-card-actions class="d-flex mt-n5">
          <v-spacer />
          <v-btn text color="primary" @click="salvar()"> salvar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SysGrupoAutocomplete from "../../../utils/crud/SysGrupoAutocomplete";
import SysFilialGrupoAutocomplete from "../../../utils/crud/SysFilialGrupoAutocomplete";
import TextFieldFormatador from "../../../utils/TextFieldFormatadorDeValor";
import { required, minValue, maxValue } from "vuelidate/lib/validators";
import TempoCoberturaPorCurvas from "../../../../api/compras/TempoCoberturaPorCurvas";

export default {
  name: "DialogCurvasCompras",
  components: {
    SysGrupoAutocomplete,
    SysFilialGrupoAutocomplete,
    TextFieldFormatador,
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue",
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    itemParaEdicao: {
      type: Object,
    },
  },
  data: () => ({
    messageError: null,
    editedItem: {
      id: "",
      grupo: "",
      filial: [],
      pqr: "",
      xyz: "",
      tempo_cobertura: "",
    },
    select: {
      pqr: [
        { text: "P - Popular", value: "P" },
        { text: "Q - Média", value: "Q" },
        { text: "R - Rara", value: "R" },
      ],
      xyz: [
        { text: "X - Ordinário", value: "X" },
        { text: "Y - Intermédiario", value: "Y" },
        { text: "Z - Vital", value: "Z" },
      ],
    },
  }),
  watch: {
    itemParaEdicao(item) {
      const { id, grupo, filial, pqr, xyz, tempo_cobertura } = item;
      this.editedItem = Object.assign(
        {},
        { id, grupo, filial: [filial], pqr, xyz, tempo_cobertura }
      );
    },
  },
  validations: {
    messageError: {
      duplicated() {
        return this.messageError === null;
      },
    },
    editedItem: {
      grupo: {
        required,
      },
      filial: {
        required,
      },
      pqr: {
        required,
      },
      xyz: {
        required,
      },
      tempo_cobertura: {
        required,
        minValue: minValue(1),
        maxValue: maxValue(99999999),
      },
    },
  },
  computed: {
    editando() {
      return this.editedItem.id && this.editedItem.id > 0;
    },
    DIALOG_ATIVO: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        this.$emit("update:modelValue", valor);
      },
    },
    grupoErros() {
      const errors = [];
      if (!this.$v.editedItem.grupo.$dirty) return errors;
      !this.$v.editedItem.grupo.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    filialErros() {
      const errors = [];
      if (!this.$v.editedItem.filial.$dirty) return errors;
      !this.$v.editedItem.filial.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    pqrErros() {
      const errors = [];
      if (!this.$v.editedItem.pqr.$dirty) return errors;
      !this.$v.editedItem.pqr.required && errors.push("Campo Obrigatório.");
      !this.$v.messageError.duplicated &&
        errors.push("Tentativa de cadastro duplicado.");
      return errors;
    },
    xyzErros() {
      const errors = [];
      if (!this.$v.editedItem.xyz.$dirty) return errors;
      !this.$v.editedItem.xyz.required && errors.push("Campo Obrigatório.");
      !this.$v.messageError.duplicated &&
        errors.push("Tentativa de cadastro duplicado.");
      return errors;
    },
    tempoCoberturaErros() {
      const errors = [];
      if (!this.$v.editedItem.tempo_cobertura.$dirty) return errors;
      !this.$v.editedItem.tempo_cobertura.required &&
        errors.push("Campo Obrigatório.");
      !this.$v.editedItem.tempo_cobertura.minValue &&
        errors.push("Valor mínimo é 1.");
      !this.$v.editedItem.tempo_cobertura.maxValue &&
        errors.push("Valor máximo é 99.999.999.");
      return errors;
    },
  },
  methods: {
    salvar() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        this.$store.dispatch(
          "loading/addRequisicao",
          TempoCoberturaPorCurvas.store(headers, this.editedItem)
            .then((response) => {
              const { token, messageError } = response.data;
              localStorage.token = token;

              if (!messageError) {
                this.fecharDialog();
                this.$emit("atualizar-lista", true);
              } else {
                this.messageError = messageError;
              }
            })
            .catch(() => this.Helpers.logout())
        );
      }
    },
    fecharDialog() {
      this.$emit("update:modelValue", false);
      this.messageError = null;
      this.$v.$reset();
      this.editedItem = {
        id: "",
        grupo: "",
        filial: "",
        pqr: "",
        xyz: "",
        tempo_cobertura: "",
      };
    },
  },
};
</script>

<style>
</style>
